<template>
    <div class=" contact" id="contact">
       <div class="container">
        <div class="row text-center">
            <div class="col-lg-5 col-12 left text-start">
                <p class="one">Feel Free To Send Us A Message About Your Website Needs</p>
                <p class="two">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed doer ket eismod tempor incididunt ut labore et dolores</p>
                <div class="d-flex">
                    <p class="one">For any enquiry, Call Us:</p>
                    <div class="ms-4 d-flex align-item-center ">
                        <!-- <i class="fa-solid fa-phone ph"></i> -->
                        <!-- <font-awesome-icon icon="fa-solid fa-user-secret"  class=" ph"/> -->
                        <p class="d-inline ms-1 mt-1">07828226965</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 col-12">
                <form  @click.prevent>
                    <div class="row text-start">
                        <div class=" col-lg-6">
                            <input  type="text" placeholder="Name" v-model="name" />
                            <span class="error-feedback" v-if="v$.name.$error">{{ v$.name.$errors[0].$message }}</span>
                        </div>
                        <div class=" col-lg-6">
                            <input type="text" placeholder="Last Name" v-model="lastname"/>
                            <span class="error-feedback" v-if="v$.lastname.$error">{{ v$.lastname.$errors[0].$message }}</span>
                        </div>
                        <div class="col-12">
                            <input type="text" placeholder="Your Email" v-model="email">
                            <span class="error-feedback" v-if="v$.email.$error">{{ v$.email.$errors[0].$message }}</span>
                        </div>
                        <div class="col-12">
                            <input class="areat" type="text" placeholder="Message">
                            <!-- <span class="error-feedback" v-if="v$.name.$error">{{ v$.name.$errors[0].$message }}</span> -->
                        </div>
                        <div class="mt-3">
                            <button class="btn fooe" @click="send()">Send Message</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
       </div>
    </div>
</template>

<script>
import { required , email , minLength } from '@vuelidate/validators';
import usevalidate from '@vuelidate/core'
    export default {
    name: 'contact',
    data(){
        return{
            // v$:usevalidate(),
            v$:usevalidate(),
            name:'',
            lastname:'',
            email:'',
        }
    },
    validations(){
        return{
            name:{required, minLength:minLength(10)},
            lastname:{required,minLength:minLength(10)},
            email:{required , email }
            
        }
    },
    methods:{
        send(){
            // this.v$.$validations();
            this.v$.$validate()
            if(this.v$.$error){
                console.log("error")
            }else{
                location.reload()
            }
        }
    }
    
    }
</script>

<style  scoped>
*{
    box-sizing: border-box;
}
.contact {
    background-image: url("../assets/contact-bg.png");
    background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        padding:160px 0 ; 
}
.left p{
    color: white;
}
.left .one{
    font-weight: 800;
    font-size: 30px;
}
.left div .one{
    font-weight: 500;
    font-size: 20px;
}
.ph {
    background-color: white;
    color:#fe3f40;
    padding: 7px;
    border-radius: 10px
}
form {
    margin-left: 30px;
        position: relative;
        background-color: #fff;
        padding: 60px 30px;
        border-radius: 20px;
}
form input{
    border-radius: 20px;
    outline: none;
    border: none;
    padding: 10px;
    background-color: #d1f3ff;
    width: 90%;
    margin:10px;
}
form input:-moz-placeholder{
    color:black;
}
.areat {
    height: 130px;;
}
.fooe {
    background-color: #03a4ed;
    color:white;
    transition: all .9s;
    border-radius: 20px;

}
.fooe:hover{
    background-color:#fe3f40;

}
.error-feedback{
    color:red;
    font-size: 0.85em
    }
</style>